import { IconProps } from '../icon';

export function ArrowWhiteSortAscIcon(props: IconProps) {
  return (
    <svg
      id="Trie_alphabétique_-_1"
      data-name="Trie alphabétique - 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="40"
      height="38.947"
      viewBox="0 0 40 38.947"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_170"
            data-name="Rectangle 170"
            width="40"
            height="38.947"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-3">
          <rect
            id="Rectangle_168"
            data-name="Rectangle 168"
            width="21.621"
            height="38.947"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Groupe_333" data-name="Groupe 333" clipPath="url(#clipPath)">
        <g id="Groupe_332" data-name="Groupe 332">
          <g id="Groupe_331" data-name="Groupe 331" clipPath="url(#clipPath)">
            <path
              id="Tracé_111"
              data-name="Tracé 111"
              d="M21.028,12.818a1.859,1.859,0,0,1-2.628-.091L12.669,6.58V37.088a1.859,1.859,0,1,1-3.718,0V6.58L3.219,12.727A1.86,1.86,0,0,1,.5,10.191L9.4.643,9.451.592h0L9.488.554,9.521.521C9.544.5,9.569.475,9.594.454L9.617.434,9.652.406,9.681.383C9.7.366,9.725.35,9.748.335l.005,0q.031-.023.062-.041a1.075,1.075,0,0,1,.1-.056Q9.946.212,9.981.2L9.995.189c.021-.011.043-.021.065-.03l.022-.01.041-.017a.07.07,0,0,1,.018-.007L10.17.114l.008,0a.707.707,0,0,1,.077-.026L10.3.07a.169.169,0,0,1,.028-.007.09.09,0,0,1,.018-.006L10.385.05h.006l.05-.011c.029-.006.056-.011.087-.015l.019,0h.01l.026,0L10.624.01h.015L10.716,0l.094,0L10.9,0l.077.005H11l.043.006.026,0h.01l.019,0,.087.015.05.011h.005l.036.008a.089.089,0,0,1,.018.006.167.167,0,0,1,.028.007l.048.015a.7.7,0,0,1,.077.026l.008,0,.029.011A.069.069,0,0,1,11.5.132l.041.017.022.01.065.03L11.639.2q.035.016.07.037a1.075,1.075,0,0,1,.1.056.482.482,0,0,1,.062.041s0,0,.006,0c.023.015.045.032.067.048l.029.023L12,.434l.023.021h0L12.1.521A.011.011,0,0,1,12.1.526l.028.028.036.037a.568.568,0,0,1,.048.052l8.9,9.548a1.858,1.858,0,0,1-.092,2.628"
              transform="translate(0)"
              fill="#fff"
            />
            <path
              id="Tracé_112"
              data-name="Tracé 112"
              d="M137.71,6.617a.535.535,0,0,1,.052-.045c-.025.021-.05.043-.073.066l.021-.021"
              transform="translate(-128.168 -6.118)"
              fill="#161615"
            />
            <path
              id="Tracé_113"
              data-name="Tracé 113"
              d="M147.209,1.253c.018-.007.037-.012.057-.018a.738.738,0,0,0-.077.026l.021-.008"
              transform="translate(-137.01 -1.15)"
              fill="#161615"
            />
            <path
              id="Tracé_114"
              data-name="Tracé 114"
              d="M149.044.836h0a.089.089,0,0,0-.018.006A.149.149,0,0,0,149,.848l.008,0,.034-.01"
              transform="translate(-138.697 -0.778)"
              fill="#161615"
            />
            <path
              id="Tracé_115"
              data-name="Tracé 115"
              d="M163.037.847l.008,0a.159.159,0,0,0-.028-.007A.083.083,0,0,0,163,.837h0l.034.01"
              transform="translate(-151.728 -0.779)"
              fill="#161615"
            />
            <path
              id="Tracé_116"
              data-name="Tracé 116"
              d="M164.411,1.253l.021.008a.743.743,0,0,0-.077-.026c.019.006.039.011.056.018"
              transform="translate(-152.99 -1.15)"
              fill="#161615"
            />
            <path
              id="Tracé_117"
              data-name="Tracé 117"
              d="M173.984,6.617l.021.021-.072-.066.051.045"
              transform="translate(-161.905 -6.118)"
              fill="#161615"
            />
            <path
              id="Tracé_118"
              data-name="Tracé 118"
              d="M137.71,6.617a.535.535,0,0,1,.052-.045c-.025.021-.05.043-.073.066l.021-.021"
              transform="translate(-128.168 -6.118)"
              fill="#161615"
            />
            <path
              id="Tracé_119"
              data-name="Tracé 119"
              d="M147.209,1.253c.018-.007.037-.012.057-.018a.738.738,0,0,0-.077.026l.021-.008"
              transform="translate(-137.01 -1.15)"
              fill="#161615"
            />
            <path
              id="Tracé_120"
              data-name="Tracé 120"
              d="M149.009.92l.019,0A.159.159,0,0,0,149,.923l.008,0"
              transform="translate(-138.697 -0.853)"
              fill="#161615"
            />
            <path
              id="Tracé_121"
              data-name="Tracé 121"
              d="M163,.836l.015.006A.089.089,0,0,0,163,.836Z"
              transform="translate(-151.728 -0.778)"
              fill="#161615"
            />
            <path
              id="Tracé_122"
              data-name="Tracé 122"
              d="M149.414.836h0a.089.089,0,0,0-.018.006l.015-.006"
              transform="translate(-139.068 -0.778)"
              fill="#161615"
            />
            <path
              id="Tracé_123"
              data-name="Tracé 123"
              d="M163.278.92l.008,0a.159.159,0,0,0-.028-.007l.019,0"
              transform="translate(-151.969 -0.853)"
              fill="#161615"
            />
            <path
              id="Tracé_124"
              data-name="Tracé 124"
              d="M164.411,1.253l.021.008a.743.743,0,0,0-.077-.026c.019.006.039.011.056.018"
              transform="translate(-152.99 -1.15)"
              fill="#161615"
            />
            <path
              id="Tracé_125"
              data-name="Tracé 125"
              d="M173.984,6.617l.021.021-.072-.066.051.045"
              transform="translate(-161.905 -6.118)"
              fill="#161615"
            />
            <g
              id="Groupe_330"
              data-name="Groupe 330"
              transform="translate(18.379)"
              opacity="0.5"
            >
              <g id="Groupe_329" data-name="Groupe 329">
                <g
                  id="Groupe_328"
                  data-name="Groupe 328"
                  clipPath="url(#clipPath-3)"
                >
                  <path
                    id="Tracé_126"
                    data-name="Tracé 126"
                    d="M266.37,26.128a1.859,1.859,0,0,1,2.628.091l5.732,6.148V1.859a1.859,1.859,0,1,1,3.718,0V32.367l5.732-6.148a1.86,1.86,0,0,1,2.72,2.537l-8.9,9.548-.047.051h0l-.036.037-.033.033c-.023.023-.048.046-.073.066l-.023.021-.034.028-.029.023c-.022.017-.044.033-.067.048l-.005,0q-.031.023-.062.041a1.073,1.073,0,0,1-.1.056q-.035.021-.07.037l-.014.007c-.021.011-.043.021-.065.03l-.022.01-.041.017a.07.07,0,0,1-.018.007l-.029.011-.008,0a.706.706,0,0,1-.077.026l-.048.015a.169.169,0,0,1-.027.007.091.091,0,0,1-.018.006l-.036.008h-.006l-.05.011c-.029.006-.056.011-.087.015l-.019,0h-.01l-.026,0-.043.006h-.015l-.077.005-.094,0-.094,0-.077-.005H276.4l-.043-.006-.026,0h-.01l-.019,0-.087-.015-.05-.011h-.005l-.036-.008a.088.088,0,0,1-.018-.006.167.167,0,0,1-.028-.007l-.048-.015a.7.7,0,0,1-.077-.026l-.008,0-.029-.011a.069.069,0,0,1-.018-.007l-.041-.017-.022-.01-.065-.03-.014-.007c-.023-.011-.047-.023-.07-.037a1.073,1.073,0,0,1-.1-.056.482.482,0,0,1-.062-.041s0,0-.006,0c-.023-.015-.045-.032-.067-.048l-.029-.023-.034-.028-.023-.021h0l-.072-.066a.011.011,0,0,1-.005-.005l-.028-.028-.036-.037a.584.584,0,0,1-.048-.052l-8.9-9.548a1.857,1.857,0,0,1,.092-2.628"
                    transform="translate(-265.778 0)"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ArrowWhiteSortAscIcon;
